import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import '../style/App.css';
import Login from "./Login";
import {checkLogin} from "../state/action/apiActions";
import {getVersion} from "../state/action/appActions";
import {LOGIN_USER, REQUEST_COMPLETE} from "../constant/reducerConstants";
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import {DEVICES_PATH, LOGIN_PATH} from "../constant/routes";
import PrivateRoute from "./util/PrivateRoute";
import DevicesOverview from "./DevicesOverview";
import Header from "./Header";
import '../style/General.css';
import ErrorFooter from "./alert/AlertFooter";
import db from "../state/persistence/db";

export const ST_BLUE_COLOR = '#3498db';

export class App extends Component {
    state = {
        scanning: true,
        results: []
    };

    componentDidMount() {
        this.props.updateVersion();
        this.props.checkLogin();
    }

    componentWillUnmount() {
        db.closeDbConnection();
    }

    render() {
        const authenticated = this.props.authCheck === REQUEST_COMPLETE;
        return (
            <div id={'app-wrapper'}>
                <Header authenticated={true} version={this.props.version}/>
                <div id={'content-wrapper'}>
                    <Switch>
                        <Route path={LOGIN_PATH} component={Login}/>
                        <PrivateRoute
                            path={DEVICES_PATH}
                            component={DevicesOverview}
                            authenticated={authenticated}/>
                        <Route component={() => <Redirect to={{pathname: DEVICES_PATH}}/>}/>
                    </Switch>
                    <div className={'overflow'}/>
                </div>
                <ErrorFooter/>
            </div>
        );
    }
}

App.propTypes = {
    authCheck: PropTypes.string
};

const mapStateToProps = state => {
    const {network} = state;
    const {app} = state;
    return {
        version: app.version,
        authCheck: network[LOGIN_USER]
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateVersion: () => {
            dispatch(getVersion);
        },
        checkLogin: () => {
            dispatch(checkLogin);
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));


// WEBPACK FOOTER //
// ./src/component/App.jsx